// MF-67 — Small segmented control to switch between views of the same data (e.g. List / Insights).
// options: [{ value, label }].
const ViewSwitch = ({ options = [], value, onChange }) => (
  <div
    role='tablist'
    style={{
      display: 'inline-flex',
      padding: 3,
      gap: 2,
      borderRadius: 10,
      background: 'rgb(226, 232, 240)'
    }}
  >
    {options.map((o) => {
      const selected = o.value === value
      return (
        <button
          key={o.value}
          type='button'
          role='tab'
          aria-selected={selected}
          onClick={() => onChange(o.value)}
          style={{
            padding: '6px 16px',
            borderRadius: 8,
            border: 'none',
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 13,
            fontWeight: selected ? 600 : 500,
            color: selected ? 'rgb(15, 23, 42)' : 'rgb(71, 85, 105)',
            background: selected ? '#fff' : 'transparent',
            boxShadow: selected ? '0 1px 2px rgba(15, 23, 42, 0.12)' : 'none'
          }}
        >
          {o.label}
        </button>
      )
    })}
  </div>
)

export default ViewSwitch
